import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import { Redirect } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert } from "@material-ui/lab"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Snackbar from "@material-ui/core/Snackbar"
import Divider from "@material-ui/core/Divider"
import Switch from "@material-ui/core/Switch"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import * as constants from "../constants"
import FloatingLabelInput from "./FloatingLabelInput"

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: { maxHeight: 400 },
})

const numberWithSeparator = (n) => {
    if (n === null || n === undefined || n === "") return "-"
    return Number(n).toLocaleString("en-US")
}

class InvestmentInsurancePlan extends Component {
    cookies = new Cookies()

    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            plans: [],
            rowsPerPage: 10,
            page: 0,
            selected_id: "",
            plan_name: "",
            description: "",
            min_capital: "",
            max_capital: "",
            plan_is_active: true,
            newMode: true,
            snackstr: "",
            showSnack: false,
            snackMode: "success",
        }
    }

    handleChangeName = (event) => {
        this.setState({ plan_name: event.target.value })
    }
    handleChangeDescription = (event) => {
        this.setState({ description: event.target.value })
    }

    handleChangeMinCapital = (value) => {
        this.setState({ min_capital: value })
    }

    handleChangeMaxCapital = (value) => {
        this.setState({ max_capital: value })
    }

    handleChangeActive = (event) => {
        this.setState({ plan_is_active: event.target.checked })
    }

    handleClickcloseTasckBar = () => {
        this.setState({ showSnack: false })
    }

    handleSelectRows = (row) => {
        this.setState({
            selected_id: row.id,
            plan_name: row.name,
            description: row.description,
            min_capital: row.min_capital !== null ? String(row.min_capital) : "",
            max_capital: row.max_capital !== null ? String(row.max_capital) : "",
            plan_is_active: parseInt(row.is_active) === 1,
            newMode: false,
        })
    }

    newMode = () => {
        this.setState({
            selected_id: "",
            plan_name: "",
            description: "",
            min_capital: "",
            max_capital: "",
            plan_is_active: true,
            newMode: true,
        })
    }

    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({ type: "WAITSHOW" })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getPlans()
                    } else {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({ type: "WITEHIDE" })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")
            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    getPlans() {
        this.props.props.props.dispatch({ type: "WAITSHOW" })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ plans: arr.data }, () => {})
                }
                self.props.props.props.dispatch({ type: "WITEHIDE" })
            }
        }
        var fd = new FormData()
        xhttp.open("POST", `${constants.BASE_URL}/InvestmentInsurance/getPlan`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    validate = () => {
        const { plan_name, min_capital, max_capital } = this.state
        if (plan_name.trim() === "") {
            this.setState({ snackstr: "لطفا نام طرح را وارد نمایید", showSnack: true, snackMode: "error" })
            return false
        }
        if (min_capital !== "" && max_capital !== "") {
            if (Number(min_capital) > Number(max_capital)) {
                this.setState({
                    snackstr: "کف سرمایه نمی‌تواند از سقف بیشتر باشد",
                    showSnack: true,
                    snackMode: "error",
                })
                return false
            }
        }
        return true
    }

    saveNewPlan = () => {
        if (!this.validate()) return

        const { plan_name, min_capital, max_capital, plan_is_active , description } = this.state
        this.props.props.props.dispatch({ type: "WAITSHOW" })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    self.newMode()
                    self.getPlans()
                } else {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({ type: "WITEHIDE" })
            }
        }
        var fd = new FormData()
        fd.append("name", plan_name)
        fd.append("description", description)
        fd.append("min_capital", min_capital)
        fd.append("max_capital", max_capital)
        fd.append("is_active", plan_is_active ? 1 : 0)
        xhttp.open("POST", `${constants.BASE_URL}/InvestmentInsurance/addPlan`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    changePlan = () => {
        if (!this.validate()) return

        const { selected_id, plan_name, min_capital, max_capital, plan_is_active , description } = this.state
        this.props.props.props.dispatch({ type: "WAITSHOW" })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    self.getPlans()
                } else {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({ type: "WITEHIDE" })
            }
        }
        var fd = new FormData()
        fd.append("id", selected_id)
        fd.append("name", plan_name)
        fd.append("description", description)
        fd.append("min_capital", min_capital)
        fd.append("max_capital", max_capital)
        fd.append("is_active", plan_is_active ? 1 : 0)
        xhttp.open("POST", `${constants.BASE_URL}/InvestmentInsurance/modifyPlan`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    deletePlan = () => {
        const { selected_id } = this.state
        if (!selected_id) return

        this.props.props.props.dispatch({ type: "WAITSHOW" })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    self.newMode()
                    self.getPlans()
                } else {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({ type: "WITEHIDE" })
            }
        }
        var fd = new FormData()
        fd.append("id", selected_id)
        xhttp.open("POST", `${constants.BASE_URL}/InvestmentInsurance/deletePlan`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 10) })
    }

    render() {
        const { classes } = this.props
        const {
            snackMode,
            snackstr,
            showSnack,
            newMode,
            selected_id,
            plan_name,
            description,
            min_capital,
            max_capital,
            plan_is_active,
            plans,
            rowsPerPage,
            page,
            redirect,
        } = this.state

        if (redirect) return <Redirect to="/" />

        return (
            <div className={classes.paperrtl} dir="rtl">
                <Snackbar
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    onClose={this.handleClickcloseTasckBar}
                    open={showSnack}
                    autoHideDuration={10000}
                >
                    <Alert severity={snackMode}>{snackstr}</Alert>
                </Snackbar>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Container component="main" maxWidth="lg">
                            <Paper elevation={4} className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Typography align="right" variant="h6">
                                            {newMode ? "ثبت طرح جدید" : `ویرایش طرح (آی‌دی: ${selected_id})`}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <FloatingLabelInput
                                            placeholder="نام طرح"
                                            handleInputt={this.handleChangeName}
                                            value={plan_name}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FloatingLabelInput
                                            placeholder="توضیحات"
                                            handleInputt={this.handleChangeDescription}
                                            value={description}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <FloatingLabelInput
                                            type="number"
                                            placeholder="کف سرمایه (ریال)"
                                            handleInputt={this.handleChangeMinCapital}
                                            value={min_capital}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <FloatingLabelInput
                                            type="number"
                                            placeholder="سقف سرمایه (ریال)"
                                            handleInputt={this.handleChangeMaxCapital}
                                            value={max_capital}
                                        />

                                    </Grid>

                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={plan_is_active}
                                                    onChange={this.handleChangeActive}
                                                    color="primary"
                                                />
                                            }
                                            label="فعال"
                                        />
                                    </Grid>

                                    <Grid item xs={12}><Divider /></Grid>

                                    <Grid item xs={12}>
                                        {newMode ? (
                                            <Button variant="outlined" color="primary" onClick={this.saveNewPlan}>
                                                ثبت طرح جدید
                                            </Button>
                                        ) : (
                                            <div style={{ width: "100%", textAlign: "right" }}>
                                                <Button variant="outlined" color="primary" onClick={this.newMode}>
                                                    طرح جدید
                                                </Button>
                                                {"  "}
                                                <Button variant="outlined" color="primary" onClick={this.changePlan}>
                                                    ثبت تغییرات
                                                </Button>
                                                {"  "}
                                                <Button variant="outlined" color="secondary" onClick={this.deletePlan}>
                                                    حذف
                                                </Button>
                                            </div>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Container>
                    </Grid>

                    <Grid item xs={12}>
                        <Container maxWidth="lg">
                            <Paper className={classes.root}>
                                <TableContainer dir="rtl">
                                    <Table aria-label="plans table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" style={{ minWidth: 20 }}>آی‌دی</TableCell>
                                                <TableCell align="center" style={{ minWidth: 80 }}>نام</TableCell>
                                                <TableCell align="center" style={{ minWidth: 80 }}>توضیحات</TableCell>
                                                <TableCell align="center" style={{ minWidth: 80 }}>کف سرمایه</TableCell>
                                                <TableCell align="center" style={{ minWidth: 80 }}>سقف سرمایه</TableCell>
                                                <TableCell align="center" style={{ minWidth: 60 }}>وضعیت</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {plans
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((row) => (
                                                    <TableRow
                                                        hover
                                                        tabIndex={-1}
                                                        key={row.id}
                                                        onClick={() => this.handleSelectRows(row)}
                                                    >
                                                        <TableCell align="center">{row.id}</TableCell>
                                                        <TableCell align="center">{row.name}</TableCell>
                                                        <TableCell align="center">{row.description}</TableCell>
                                                        <TableCell align="center">{numberWithSeparator(row.min_capital)}</TableCell>
                                                        <TableCell align="center">{numberWithSeparator(row.max_capital)}</TableCell>
                                                        <TableCell align="center">
                                                            {parseInt(row.is_active) === 1 ? (
                                                                <span style={{ color: "green" }}>فعال</span>
                                                            ) : (
                                                                <span style={{ color: "red" }}>غیرفعال</span>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    count={plans.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </Paper>
                        </Container>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(InvestmentInsurancePlan)